import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.header = {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      mb: [13, 14],
    };

    this.heading = {
      variant: 'text.h2',
    };

    this.footer = {
      display: ['flex', 'none'],
      mt: 14,
      px: 10,
    };
  })()
);
